"use strict"

import React from "react"
import {observer} from "mobx-react"

import UIStore from "../stores/UIStore"

import "./cennik.less"

const BALIKY = [
	{
		name: "BASIC",
		price: "49",
		users: "1 ambulancia · 1 lekár a 1 sestra",
		features: [
			"Základný kalendár",
			"Kartotéka pacientov",
			{
				text: "Evidencia zdravotnej dokumentácie v rozsahu záznamu z vyšetrenia:",
				sub: [
					"dekurz",
					"preskripcia",
					"žiadanky",
					"laboratórne výsledky z laboratórií",
					"klinické hodnoty",
					"PN a OČR",
					"anamnéza",
					"očkovania",
					"dispenzár a evidencia chronických problémov pacienta"
				]
			},
			"Evidencia zmlúv so zdravotnými poisťovňami",
			"Vykazovanie zdravotnej starostlivosti",
			"Základné reporty a štatistiky vrátane kontrolných prehľadov pred vykazovaním do ZP",
			"Integrácia na eZdravie v rozsahu povinných záznamov"
		]
	},
	{
		name: "STANDARD",
		price: "69",
		users: "1 ambulancia · 1 lekár a 2 sestry",
		highlighted: true,
		badge: "NAJČASTEJŠIA VOĽBA",
		includes: "VŠETKO Z BASIC, NAVYŠE",
		features: [
			"Automatické bodovanie podľa poskytnutej služby",
			"Rozšírený kalendár — plánovač a multikalendár",
			"Vlastné logo v dokumentoch",
			"Hromadné odosielanie e-mailov pacientom",
			"Automatické odosielanie SMS — pripomienka pred termínom vyšetrenia, vystavenie receptu, pozvánka na vyšetrenie",
			"100 SMS mesačne v cene",
			"Nahratie príloh a dokumentov priamo do karty pacienta",
			"Vytváranie vlastných jednoduchých tlačových zostáv"
		]
	},
	{
		name: "ADVANCED",
		price: "89",
		users: "1 ambulancia · 1 lekár a 2 sestry",
		includes: "VŠETKO ZO STANDARD, NAVYŠE",
		features: [
			"Žiadankové portály Medirex, Synlab a Unilabs",
			"Pečiatka s podpisovým vzorom do dokumentov",
			"E-mailový klient — pošta priamo v ambee",
			"250 SMS mesačne v cene",
			"Objednávací systém — vlastné rozhranie aj portály tretích strán",
			"Hodnotiaci e-mail pacientovi so žiadosťou o recenziu na Google",
			"Zľava 20 % na každého ďalšieho lekára a sestru"
		]
	}
]

const PRIPLATKY = [
	{
		title: "AMBULANCIE A POSKYTOVATELIA",
		note: "cena balíka platí pre jednu ambulanciu, teda jeden P kód a jednu kartotéku",
		items: [
			{
				name: "Ďalšia ambulancia — 2. a 3.",
				desc:
					"Ďalší P kód, vlastná kartotéka a vlastné vykazovanie do poisťovní. So zľavou 20 % z ceny balíka — BASIC 39,20 €, STANDARD 55,20 €, ADVANCED 71,20 €.",
				price: "od 39,20 €",
				unit: "/ mes"
			},
			{
				name: "Ďalšia ambulancia — od 4.",
				desc:
					"So zľavou 35 % z ceny balíka — BASIC 31,85 €, STANDARD 44,85 €, ADVANCED 57,85 €. Úložisko aj SMS platia pre každú ambulanciu zvlášť.",
				price: "od 31,85 €",
				unit: "/ mes"
			},
			{
				name: "Ďalší poskytovateľ",
				desc: "Iné IČO a vlastné zmluvy so zdravotnými poisťovňami — vlastný balík podľa rozsahu svojej ambulancie.",
				price: "cena balíka",
				muted: true
			}
		]
	},
	{
		title: "ĎALŠÍ POUŽÍVATELIA",
		items: [
			{
				name: "Ďalší atestovaný lekár",
				desc:
					"Lekár s vlastným A kódom, v rámci tej istej ambulancie. Vrátane jeho registrácie a napojenia na eZdravie — tá je viazaná na lekára, nie na ambulanciu.",
				price: "14,99 €",
				unit: "/ mes"
			},
			{
				name: "Ďalšia sestra alebo neatestovaný lekár",
				desc: "Nad rámec sestier zahrnutých v balíku.",
				price: "9,99 €",
				unit: "/ mes"
			},
			{
				name: "Konto pre recepčnú",
				desc: "Prístup bez zdravotnej dokumentácie — kalendár, objednávanie, kontakt s pacientom.",
				price: "7,99 €",
				unit: "/ mes"
			},
			{
				name: "Konto pre manažéra",
				desc: "Prehľady, reporty a ekonomika ambulancie bez prístupu k dokumentácii.",
				price: "12,99 €",
				unit: "/ mes"
			}
		]
	},
	{
		title: "DOPLNKOVÉ FUNKCIE",
		note: "dajú sa doobjednať ku ktorémukoľvek balíku",
		items: [
			{
				name: "Žiadankové portály",
				desc: "Prepojenie na žiadankové portály Medirex, Synlab a Unilabs. V balíku ADVANCED sú v cene.",
				price: "9,99 €",
				unit: "/ mes"
			},
			{
				name: "Operačný protokol",
				desc: "Evidencia operačných výkonov a zápis operačného protokolu do karty pacienta.",
				price: "6,99 €",
				unit: "/ mes"
			},
			{
				name: "Estetický zákrok",
				desc: "Evidencia aplikovaných látok pri estetických zákrokoch.",
				price: "6,99 €",
				unit: "/ mes"
			}
		]
	},
	{
		title: "OBJEDNÁVANIE A ÚLOŽISKO",
		items: [
			{
				name: "Objednávací systém",
				desc:
					"Objednávanie pacientov cez vlastné rozhranie ambulancie alebo cez portál tretej strany — TopDoctor, eČakáreň a ďalšie.",
				price: "3,99 €",
				unit: "/ mes"
			},
			{
				name: "Úložisko nad 10 GB",
				desc: "Prvých 10 GB je v cene každého balíka. Za každých ďalších začatých 20 GB.",
				price: "2,99 €",
				unit: "/ mes"
			},
			{
				name: "SMS nad rámec balíka",
				desc: "V balíku BASIC sa účtujú všetky odoslané SMS.",
				price: "0,06 €",
				unit: "/ SMS"
			}
		]
	},
	{
		title: "PODPISOVÝ PAD",
		items: [
			{
				name: "Podpisový PAD — kúpa",
				desc: "Jednorazový nákup zariadenia vrátane inštalácie a integrácie do ambee.",
				price: "599 €"
			},
			{
				name: "Technická podpora PADu",
				desc: "Pri zakúpenom zariadení. Servis, aktualizácie a riešenie problémov.",
				price: "3,99 €",
				unit: "/ mes"
			},
			{
				name: "Podpisový PAD — prenájom",
				desc: "Zariadenie v prenájme, technická podpora v cene. Minimálna viazanosť 12 mesiacov.",
				price: "29,90 €",
				unit: "/ mes"
			}
		]
	},
	{
		title: "ŠKOLENIE A ĎALŠIE SLUŽBY",
		note: "prvá hodina školenia pri úvodnej prezentácii je v cene",
		items: [
			{
				name: "Dodatočné zaškolenie",
				desc:
					"Pre sestru, lekára alebo ktoréhokoľvek člena personálu, ktorý nebol na úvodnom školení. Účtuje sa po 30 minútach.",
				price: "59 €",
				unit: "/ hod"
			},
			{
				name: "Iné služby na základe požiadaviek zákazníka",
				desc:
					"Práce nad rámec balíka a príplatkových služieb — na základe individuálnej požiadavky ambulancie. Účtuje sa po 30 minútach.",
				price: "69 €",
				unit: "/ hod"
			}
		]
	},
	{
		title: "MIGRÁCIA KARTOTÉKY",
		section: true,
		items: [
			{
				name: "História do 2 rokov",
				desc:
					"Import dát dodaných ambulanciou — dekurzy a preskripcie. Export z pôvodného systému zabezpečuje ambulancia.",
				price: "zdarma",
				free: true
			}
		]
	}
]

const KROKY = [
	{title: "Prezentácia systému", text: "Online cez TeamViewer, 1–1,5 hodiny. Zdarma a nezáväzne."},
	{title: "Testovacia verzia", text: "Prístup do testovacieho prostredia, vyskúšate si to sami. Zdarma."},
	{title: "Nasadenie", text: "Kartotéka, eZdravie, poisťovne a nastavenie fakturácie."},
	{title: "Spustenie", text: "Systém je pripravený. Doškolenie a konzultácie podľa potreby."}
]

@observer
export default class Cennik extends React.Component {
	renderFeature(feature, idx) {
		if (typeof feature === "string") {
			return <li key={idx}>{feature}</li>
		}

		return (
			<li key={idx}>
				{feature.text}
				<ul className="cennik-sublist">
					{feature.sub.map((sub, subIdx) => (
						<li key={subIdx}>{sub}</li>
					))}
				</ul>
			</li>
		)
	}

	render() {
		return (
			<section ref={(sec) => (UIStore.cennikRef = sec)} className="bg-white cennik">
				<div className="container">
					<div className="cennik-header">
						<div>
							<h2 className="cennik-title">Cenník</h2>
							<p className="cennik-subtitle">
								Ambulantný systém am<b>bee</b> v troch balíkoch. Ceny sú za mesiac a <b>bez DPH</b>.
							</p>
						</div>
						<span className="cennik-valid">Cenník platný od 1. 10. 2026</span>
					</div>

					<div className="row cennik-packages">
						{BALIKY.map((balik) => (
							<div key={balik.name} className="col-lg-4 mb-4 mb-lg-0 d-flex">
								<div className={`cennik-card${balik.highlighted ? " cennik-card-highlighted" : ""}`}>
									{balik.badge && <span className="cennik-badge">{balik.badge}</span>}
									<h3 className="cennik-card-name">{balik.name}</h3>
									<div className="cennik-card-price">{balik.price} €</div>
									<div className="cennik-card-period">ZA MESIAC · BEZ DPH</div>
									<div className="cennik-card-users">{balik.users}</div>
									{balik.includes && <div className="cennik-card-includes">{balik.includes}</div>}
									<ul className="cennik-features">{balik.features.map((f, idx) => this.renderFeature(f, idx))}</ul>
								</div>
							</div>
						))}
					</div>

					<div className="cennik-cloud">
						<span className="cennik-cloud-title">
							am<b>bee</b> je skutočný cloudový systém
						</span>
						<span className="cennik-cloud-text">
							Žiadny server v ambulancii, žiadna inštalácia, žiadny technik. Prihlásite sa odkiaľkoľvek a dáta sa
							zálohujú samy.
						</span>
					</div>

					<div className="cennik-section-title">
						PRÍPLATKOVÉ SLUŽBY <span className="cennik-section-note">— ku každému balíku, mesačne</span>
					</div>
					<div className="cennik-addons">
						{PRIPLATKY.map((group) => (
							<div key={group.title} className="cennik-addon-group">
								<div className={group.section ? "cennik-section-title" : "cennik-addon-group-title"}>
									{group.title}
									{group.note && <span className="cennik-section-note"> — {group.note}</span>}
								</div>
								{group.items.map((item) => (
									<div key={item.name} className="cennik-addon-row">
										<div className="cennik-addon-name">{item.name}</div>
										<div className="cennik-addon-desc">{item.desc}</div>
										<div
											className={`cennik-addon-price${item.free ? " cennik-addon-free" : ""}${
												item.muted ? " cennik-addon-muted" : ""
											}`}
										>
											{item.price}
											{item.unit && <span className="cennik-addon-unit"> {item.unit}</span>}
										</div>
									</div>
								))}
							</div>
						))}
					</div>

					<div className="cennik-section-title">AKO TO PREBIEHA</div>
					<div className="row cennik-steps">
						{KROKY.map((krok, idx) => (
							<div key={krok.title} className="col-lg-3 col-sm-6 mb-3 mb-lg-0">
								<span className="cennik-step-number">{idx + 1}</span>
								<div className="cennik-step-title">{krok.title}</div>
								<div className="cennik-step-text">{krok.text}</div>
							</div>
						))}
					</div>

					<hr className="cennik-divider" />

					<div className="cennik-footer">
						<div>
							<div className="cennik-footer-question">Máte otázku k cenníku?</div>
							<a href="mailto:podpora@ambee.sk">podpora@ambee.sk</a> ·{" "}
							<a href="tel:+421911341919" className="cennik-footer-phone">
								+421 911 34 19 19
							</a>
						</div>
						<div className="cennik-footer-note">
							Všetky ceny sú <b className="cennik-blue">bez DPH</b>, v eurách. Fakturujeme{" "}
							<b className="cennik-blue">mesačne</b>. Pri platbe vopred dávame zľavu:{" "}
							<b className="cennik-blue">kvartálne 2 %</b>, <b className="cennik-blue">polročne 3 %</b>,{" "}
							<b className="cennik-blue">ročne 5 %</b>.
						</div>
					</div>
				</div>
			</section>
		)
	}
}

